import { Link } from 'react-router-dom'
import { PageHeader } from '@/components/page-header'
import { PageShell } from '@/components/page-shell'

export function NotFoundPage() {
  return (
    <PageShell>
      <PageHeader title="Seite nicht gefunden" description="Diese Route gibt es nicht." />
      <Link to="/dashboard" className="text-brand text-sm underline underline-offset-4">
        Zurück zur Übersicht
      </Link>
    </PageShell>
  )
}
